import React, { FunctionComponent } from 'react';
import { Route, BrowserRouter as Router, StaticRouter } from 'react-router-dom';
import { ExtendedStringifyOptions, QueryParamProvider, transformSearchStringJsonSafe } from 'use-query-params';
import { isSSR } from './ssr';

const queryStringifyOptions: ExtendedStringifyOptions = {
  transformSearchString: transformSearchStringJsonSafe,
};

export function AddQueryProvider<T>(Component: FunctionComponent<T>): FunctionComponent<T & { location?: string }> {
  if (isSSR) {
    const SsrComponent: FunctionComponent<T & { location?: string }> = (props) => (
      <StaticRouter location={props.location}>
        <QueryParamProvider ReactRouterRoute={Route} stringifyOptions={queryStringifyOptions}>
          <Component {...props} />
        </QueryParamProvider>
      </StaticRouter>
    );
    return SsrComponent;
  }

  const BrowserComponent: FunctionComponent<T & { location?: string }> = (props) => (
    <Router>
      <QueryParamProvider ReactRouterRoute={Route} stringifyOptions={queryStringifyOptions}>
        <Component {...props} />
      </QueryParamProvider>
    </Router>
  );

  return BrowserComponent;
}
